<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row clearfix" v-if="checkActionPerm('create')">
            <div class="left">
                <button type="button" class="swb-btn swb-btn-small" @click="saveData(true)">新增业务范围</button>
            </div>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect"
                          :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth"
                          :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, DomSizeWatcher, Routes} from '../../app.vues'

    import {checkUserActionPerm} from '../index'
    import {getDefaultPageSizes} from '../../app.conf'
    import {openBizPermScopeDlg, showPermScopRefMerchtTplRolList} from './selectDlg'

    import userApi from '../../api/user';
    import merchtAllApi from '../../api/merchtAll'

    import SwbMerchtBizPermScopeSave from './MerchtBizPermScopeSave';

    Vue.regist(SwbMerchtBizPermScopeSave);

    import SwbMerchtBizPermScopeBusinessSet from './MerchtBizPermScopeBusinessSet';

    Vue.regist(SwbMerchtBizPermScopeBusinessSet);

    export default {
        name: 'swb-mercht-biz-perm-scope-list',
        path: '/mercht/biz/perm/scope/list',
        desc: '商户业务权限范围',
        data: function () {
            return {
                confKey: "swb-mercht-biz-perm-scope-list",
                queryOnLoad: true,
                // 分页信息
                theTableHeight: 300,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                                 //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {}
                    ,
                    sortItemList: [],
                    sortItems: {}
                }
                ,
                // 其他信息
                scopeEntity: null
            }
        },
        created: function () {
            this.getCurrUserInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], .simple-row'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            getCurrUserInfo() {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if (result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity;
                        self.scopeEntity = scopeEntity;
                    }
                });
            },
            onQueryConfigReady: function (event) {
                //
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'comLevel': function (row, colName, colValue, rowIndex, colConf) {
                        if (!row.shopFlag) {
                            if (row.comLevel1) {
                                return '一级业务单元';
                            } else if (row.comLevel2) {
                                return '二级业务单元';
                            } else if (row.comLevel3) {
                                return '三级业务单元';
                            } else if (row.comLevel4) {
                                return '四级业务单元';
                            }
                        }
                    },
                    'bizPermOrgFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.bizPermFlag) {
                            if (row.bizPermOrgFlag == 1) {
                                return '仅本机构';
                            } else if (row.bizPermOrgFlag == 3) {
                                return '本机构及以下';
                            }
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        if (self.checkActionPerm('update') && row.createMerchantId == self.scopeEntity.id) {
                            btnList.push({
                                name: 'update',
                                text: '编辑'
                            })
                        }
                        if (self.checkActionPerm('biz_scope') && row.bizPermFlag) {
                            btnList.push({
                                name: 'biz_scope',
                                text: '数据范围'
                            })
                        }
                        if (self.checkActionPerm('copy_biz_scope')) {
                            btnList.push({
                                name: 'copy_biz_scope',
                                text: '复制'
                            })
                        }
                        if (self.checkActionPerm('select_tpl_rol')) {
                            btnList.push({
                                name: 'select_tpl_rol',
                                text: '查询关联的职责权限'
                            })
                        }
                        if (self.checkActionPerm('disable') && row.createMerchantId == self.scopeEntity.id) {
                            btnList.push({
                                name: 'disable',
                                text: row.disabled ? '启用' : '禁用'
                            })
                        }
                        if (self.checkActionPerm('delete') && row.disabled && row.createMerchantId == self.scopeEntity.id) {
                            btnList.push({
                                name: 'delete',
                                text: '删除'
                            })
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if (btnName == "update") {
                            self.saveData(false, row);
                        } else if (btnName == "biz_scope") {
                            self.showBusinessSetDlg(row)
                        } else if (btnName == 'copy_biz_scope') {
                            self.saveData(null, row);
                        } else if (btnName == "disable") {
                            self.disableData(row);
                        } else if (btnName == 'select_tpl_rol') {
                            self.showMerchtTplRolList(row);
                        } else if (btnName == 'delete') {
                            self.doDelete(row);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            checkActionPerm: function (action) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, null);
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            getDataList() {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                // 调用查询接口
                merchtAllApi.getMerchtBizPermScopeList(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        //
                        self.renderTable(result.data.rows, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            saveData(isAdd, row) {
                let title = Utils.isNoB(isAdd) ? "业务范围 - 复制" : isAdd ? "业务范围 - 添加" : "业务范围 - 更新";
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: title,
                    width: 700,
                    height: 600,
                    showCloseBtn: true,
                    template: '<swb-mercht-biz-perm-scope-save :item="bizScope" :copeBizPerm="copeBizPerm" ref="swb_mercht_biz_perm_scope_save"></swb-mercht-biz-perm-scope-save>',
                    data: {
                        bizScope: row,
                        copeBizPerm: Utils.isNoB(isAdd),    // 复制模式
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_mercht_biz_perm_scope_save.getDlgResult() || {};
                        if (result.type == 'info') {
                            let bizScope = result.data || {};
                            if (Utils.isNoB(isAdd) || isAdd) {
                                if (Utils.isNoB(isAdd)) {   // 复制功能
                                    bizScope.srcId = bizScope.id;
                                    bizScope.id = null;
                                }
                                let theLoading = MsgBox.loading();
                                merchtAllApi.saveMerchtBizPermScope(bizScope, function (result) {
                                    theLoading.close();
                                    if (result.type == 'info') {
                                        theDlg.close();
                                        self.$message.success("操作成功");
                                        self.getDataList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            } else {
                                let theLoading = MsgBox.loading();
                                merchtAllApi.updateMerchtBizPermScope(bizScope, function (result) {
                                    theLoading.close();
                                    if (result.type == 'info') {
                                        theDlg.close();
                                        self.$message.success("操作成功");
                                        self.getDataList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            }
                        }
                        return false;
                    }
                });
            },
            // 删除
            disableData: function (row) {
                let self = this;
                this.$confirm("确定要" + (row.disabled ? "启用" : "禁用") + "吗", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoading = MsgBox.loading();
                    let postData = {
                        id: row.id,
                        disabled: !row.disabled
                    };
                    merchtAllApi.doMerchtBizPermScopeDisable(postData, function (result) {
                        theLoading.close();
                        if (result.type === "info") {
                            MsgBox.success("操作成功");
                            self.getDataList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            showBusinessSetDlg(row) {
                let self = this;
                openBizPermScopeDlg(row.id, row.createMerchantId != this.scopeEntity.id, function () {
                    self.getDataList();
                });
            },
            showMerchtTplRolList(row) {
                showPermScopRefMerchtTplRolList(row);
            },
            // 删除
            doDelete: function (row) {
                let self = this;
                self.$confirm('确定要删除该业务范围吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = row.id;
                    let theLoad = MsgBox.loading();
                    merchtAllApi.deleteMerchtBizPermScope(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            self.getDataList();
                            MsgBox.success('操作成功');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/MerchtBizPermScopeList.vue